export default __webpack_public_path__ + "efa5c08e6708729b6fdf59fbc222ac31.jpg";